import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,

  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAIL
} from '../actions'

const INIT_STATE = {
  forgotPasswordLoading: false,
  forgotPasswordError: '',
  forgotPassword: [],
  setPasswordLoading: false,
  setPasswordError: '',
  setPassword: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    /* forgot password */
    case FORGOT_PASSWORD:
      return { ...state, forgotPasswordLoading: true, forgotPasswordError: '', saveType: action.payload.forgotPassword.saveType }
    case FORGOT_PASSWORD_SUCCESS:
      return { ...state, forgotPasswordLoading: false, forgotPassword: action.payload.forgotPassword, forgotPasswordError: '' }
    case FORGOT_PASSWORD_FAIL:
      return { ...state, forgotPasswordLoading: false, forgotPassword: [], forgotPasswordError: action.payload.message }

    /* set password */
    case SET_PASSWORD:
      return { ...state, setPasswordLoading: true, setPasswordError: '', saveType: action.payload.setPassword.saveType }
    case SET_PASSWORD_SUCCESS:
      return { ...state, setPasswordLoading: false, setPassword: action.payload.setPassword, setPasswordError: '' }
    case SET_PASSWORD_FAIL:
      return { ...state, setPasswordLoading: false, setPassword: [], setPasswordError: action.payload.message }

    default:
      return { ...state }
  }
}